export const dialogStyles = theme => ({
    popUpTitle: {
        backgroundColor: '#00a3e0',
        height: '50px',
        padding: '0px',
        marginBottom: '10px'
    },
    popUpHeader: {
        color: '#fff',
        fontWeight: 'normal',
        margin: '10px'
    },
    popupMessage: {
        color: '#666',
        fontWeight: 'normal',
        fontSize: '13px'
    },
});

export const popupContentStyles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing.unit,
    },
    withoutLabel: {
        marginTop: theme.spacing.unit * 3,
    },
    textField: {
        flexBasis: 200,
    },
    btnPrimary: {
        backgroundColor: '#297DFD',
        border: '#297DFD',
        textTransform: 'capitalize',
        fontSize: '13px',
        fontWeight: 'bold',
        margin: '5px',
    },
    btnSecondary: {
        color: '#595959',
        backgroundColor: '#fff',
        fontWeight: 'bold',
        border: '1px solid #C5C5C5',
        float: 'left',
        textTransform: 'capitalize',
        fontSize: '13px',
        margin: '5px',
        '&:hover': {
            backgroundColor: '#fff',
            color: '#595959',
        },
    },
    btnSection: {
        marginTop: '15px',
        width: '100%',
        display: 'inline-block'
    },
    row: {
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        // margin: '8px',
        width: '100%',
        marginBottom: '10px',
        marginLeft: '10px',
    },
    label: {
        color: '#595959',
        minWidth: '25% !important',
        textAlign: 'left',
        marginRight: '2%',
        marginTop: '5px',
        paddingTop: '2px',
        fontSize: '13px'
    },
    input: {
        minWidth: '250px !important',
    },
    menuOptions: {
        fontSize: '13px',
        color: '#595959',
    },
    dropdownOptions: {
        fontSize: '16px',
        color: '#444444',
        paddingTop: '0px',
        paddingBottom: '0px',
        height: '40px',
        
        '&:hover': {
            backgroundColor: '#EFF5FF',
        },
        '&:focus': {
            backgroundColor: '#EFF5FF',
        },
        '&:active': {
            backgroundColor: '#EFF5FF',
        },
        '&:checked': {
            backgroundColor: '#EFF5FF',
        },
    },
    enterpriseSelectField: {
        fontSize: '13px',
        color: '#595959',
    }
});